import React, { useCallback } from 'react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import { TagDropdownWithDrawerCreate } from 'subapps/settings/components/TagDropdown'
import DropdownMenu from '../DropdownMenu'
import EmailReply from './EmailReply'
import { styles } from './styles'

export default function RuleValue({
  value,
  onDropdownSelect,
  onToAgentSelect,
  selectedValue,
  selectToAgentValue,
  onInputBlur,
  onInputChange,
  errorMessage,
  valueKey,
  dataType = 'AUTO',
  valueType,
  paramType,
  itemKey,
}) {
  const onTagSelect = useCallback(
    tag => {
      onDropdownSelect(tag && tag[paramType])
    },
    [onDropdownSelect, paramType]
  )

  if (dataType === 'TAGS') {
    return (
      <TagDropdownWithDrawerCreate
        tagId={paramType === 'id' && valueKey}
        tagName={paramType === 'name' && valueKey}
        onTagSelect={onTagSelect}
        size="small"
      />
    )
  }

  if (['AUTO', 'LIST'].includes(dataType) && Array.isArray(value)) {
    return (
      <div css={styles.dropdownContainer}>
        <Dropdown
          overlay={<DropdownMenu data={value} />}
          onSelect={onDropdownSelect}
          selectedKey={valueKey}
        >
          <Dropdown.Button size="small" css={styles.dropdownBtn}>
            {selectedValue || <>&nbsp;</>}
          </Dropdown.Button>
        </Dropdown>
      </div>
    )
  }
  if (['AUTO', 'TEXT'].includes(dataType)) {
    return (
      <Field
        name={itemKey?.toString()}
        value={valueKey || ''}
        onChange={onInputChange}
        onBlur={onInputBlur}
        css={styles.field}
        validateStatus={errorMessage ? 'error' : undefined}
        help={errorMessage}
        autoFocus
      />
    )
  }

  if (
    ['MessageTemplate', 'NOTE'].includes(dataType) &&
    valueType === 'ReplyAgent'
  ) {
    return (
      <EmailReply
        onDropdownSelect={onToAgentSelect}
        valueKey={selectToAgentValue}
        dataType={dataType}
      />
    )
  }

  return null
}
